import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type ProcessStep = {
  number: string;
  title: string;
  description: string;
};
const steps: ProcessStep[] = [{
  number: "01",
  title: "MATERIAS PRIMAS",
  description: "Todo empieza con los insumos."
}, {
  number: "02",
  title: "ELEGÍ LA FÓRMULA",
  description: "Seguí el procedimiento del material."
}, {
  number: "03",
  title: "FABRICÁ EL PRODUCTO",
  description: "Llevá la fórmula a una preparación real."
}, {
  number: "04",
  title: "PRESENTÁ TU PRODUCTO",
  description: "Calculá costos, prepará su presentación y dejalo listo para comercializar."
}];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function ProcessTimeline() {
  const reduceMotion = useReducedMotion();
  return <>
      <div className="relative mx-auto mt-12 max-w-xl text-left lg:hidden" data-id="element-271" data-mp="tyiuty8j1df0">
        <motion.div aria-hidden="true" className="absolute bottom-5 left-[13px] top-3 w-px origin-top bg-[#69b7ff]" initial={reduceMotion ? false : {
        scaleY: 0
      }} whileInView={reduceMotion ? undefined : {
        scaleY: 1
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.65,
        ease: enterEase
      }} data-id="element-272" data-mp="2a8lbmnksobid" />
        <ol className="relative grid gap-7" data-id="element-273" data-mp="2jawdg3i5svto">
          {steps.map((step, index) => {
          const isFinal = index === steps.length - 1;
          return <motion.li key={step.number} className="grid grid-cols-[28px_1fr] gap-4" initial={reduceMotion ? false : {
            opacity: 0,
            y: 8
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.4,
            delay: 0.12 + index * 0.12,
            ease: enterEase
          }} data-id="element-274" data-mp="1qkwbodiyfyv1" data-mpi={index}>
                <span className={`relative z-10 flex h-7 w-7 items-center justify-center rounded-full border text-[10px] font-extrabold ${isFinal ? "border-[#0077e8] bg-[#0077e8] text-white" : "border-[#69b7ff] bg-[#0b1d3a] text-[#9ed1ff]"}`} data-id="element-275" data-mp="17u678kdqk402">{step.number}</span>
                <div className="pt-0.5" data-id="element-276" data-mp="2a6sy0ohw5qzf">
                  <h3 className="text-sm font-extrabold tracking-[0.02em] text-white" data-id="element-277" data-mp="2a5q6cecqvkig">{step.title}</h3>
                  <p className="mt-2 max-w-sm text-sm leading-6 text-[#afc4df]" data-id="element-278" data-mp="2oyti253nn419">{step.description}</p>
                  {isFinal && <span className="mt-4 block h-px w-12 bg-[#0077e8]" aria-hidden="true" data-id="element-279" data-mp="1w81n1aybslfi" />}
                </div>
              </motion.li>;
        })}
        </ol>
      </div>

      <div className="relative mx-auto mt-14 hidden max-w-6xl lg:block" data-id="element-280" data-mp="1rat0ky659v8g">
        <motion.div aria-hidden="true" className="absolute left-[7%] right-[7%] top-[13px] h-px origin-left bg-[#69b7ff]" initial={reduceMotion ? false : {
        scaleX: 0
      }} whileInView={reduceMotion ? undefined : {
        scaleX: 1
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.65,
        ease: enterEase
      }} data-id="element-281" data-mp="259izmjciy4zg" />
        <ol className="relative grid grid-cols-4 gap-8 text-left" data-id="element-282" data-mp="3k5ki1qjovurp">
          {steps.map((step, index) => {
          const isFinal = index === steps.length - 1;
          return <motion.li key={step.number} initial={reduceMotion ? false : {
            opacity: 0,
            y: 8
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.4,
            delay: 0.12 + index * 0.12,
            ease: enterEase
          }} data-id="element-283" data-mp="3a7o2mmjpydns" data-mpi={index}>
                <span className={`relative z-10 flex h-7 w-7 items-center justify-center rounded-full border text-[10px] font-extrabold ${isFinal ? "border-[#0077e8] bg-[#0077e8] text-white" : "border-[#69b7ff] bg-[#0b1d3a] text-[#9ed1ff]"}`} data-id="element-284" data-mp="3t7aa8yleaxqj">{step.number}</span>
                <h3 className="mt-5 text-sm font-extrabold tracking-[0.02em] text-white" data-id="element-285" data-mp="pnyz9lu7xomv">{step.title}</h3>
                <p className="mt-2 text-sm leading-6 text-[#afc4df]" data-id="element-286" data-mp="32xl0rcq6eu22">{step.description}</p>
                {isFinal && <span className="mt-4 block h-px w-12 bg-[#0077e8]" aria-hidden="true" data-id="element-287" data-mp="2xyhwhui0srv5" />}
              </motion.li>;
        })}
        </ol>
      </div>
    </>;
}